export const allowedAtlassianFields: {
  Query: string[];
  Mutation: string[];
  Subscription: string[];
} = {
  Query: ['activities', 'echo'],
  Mutation: [],
  Subscription: [],
};
